import { InRow } from "common/Grid";
import { GrClose } from "react-icons/gr";

export const Dialog = ({isOpened, classNames, title, header, children, footer, onClose}) =>
{
  if (!isOpened)
  {
    return <></>;
  }
  const isTitle = onClose || title;
  return (

    <div className='ui-dialog-portal fixed top-0 left-0 w-screen h-screen z-[999] flex flex-col items-center justify-center'>
      <div className='ui-dialog-background absolute top-0 left-0 w-full h-full z-[1] bg-white opacity-30'></div>
      <section className={['ui-dialog absolute z-[2] box-border text-black bg-white border border-[hsl(213,24%,84%)] rounded-sm shadow-lg max-h-[90vh] flex flex-col', ...(classNames ?? [])].join(' ')}>
        {
          isTitle
          ? <header className={['title p-4 flex items-center flex-row text-black bg-primary-location_bg', onClose ? 'closable' : ''].join(' ')}>
              {
                onClose ? <InRow classNames={['justify-between w-full']}><div>{title}</div> <GrClose onClick={onClose} style={{cursor: 'pointer'}}/> </InRow> : title
              }
            </header>
          : <></>
        }
        <div className='body overflow-auto grid grid-rows-[auto_1fr_auto]'>
          {header && <header className='header grid-area-header'>{header}</header>}
          <div className='content grid-area-content p-4'>{children}</div>
          {footer && <footer className='footer grid-area-footer p-4'>{footer}</footer>}
        </div>
      </section>
    </div>
  );
};

export const ModalDialog = Dialog;
